<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12 mb-4">
        <h2 class="text-white">Bienvenido {{ user.name }}</h2>
        <p class="text-white text-sm">Panel de métricas y estadísticas</p>
      </div>

      <!-- Tarjetas de métricas -->
      <div class="col-lg-3 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-uppercase text-muted mb-0">Tareas Asignadas</h6>
                <h3 class="mb-0">{{ metrics.totalTasks }}</h3>
              </div>
              <div class="icon icon-shape bg-gradient-primary shadow text-center border-radius-md">
                <i class="ni ni-briefcase-24 text-lg opacity-10" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-uppercase text-muted mb-0">Tareas Pendientes</h6>
                <h3 class="mb-0">{{ metrics.pendingTasks }}</h3>
              </div>
              <div class="icon icon-shape bg-gradient-warning shadow text-center border-radius-md">
                <i class="ni ni-time-alarm text-lg opacity-10" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-uppercase text-muted mb-0">Tareas Entregadas</h6>
                <h3 class="mb-0">{{ metrics.deliveredTasks }}</h3>
              </div>
              <div class="icon icon-shape bg-gradient-info shadow text-center border-radius-md">
                <i class="ni ni-check-bold text-lg opacity-10" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-uppercase text-muted mb-0">Tareas Completadas</h6>
                <h3 class="mb-0">{{ metrics.completedTasks }}</h3>
              </div>
              <div class="icon icon-shape bg-gradient-success shadow text-center border-radius-md">
                <i class="ni ni-like-2 text-lg opacity-10" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tarjetas de ganancias -->
      <div class="col-lg-6 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-uppercase text-muted mb-0">Total Ganado</h6>
                <h3 class="mb-0">${{ formatCurrency(metrics.totalEarned) }}</h3>
              </div>
              <div class="icon icon-shape bg-gradient-success shadow text-center border-radius-md">
                <i class="ni ni-money-coins text-lg opacity-10" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="text-uppercase text-muted mb-0">Total Pagado</h6>
                <h3 class="mb-0">${{ formatCurrency(metrics.totalPaid) }}</h3>
              </div>
              <div class="icon icon-shape bg-gradient-info shadow text-center border-radius-md">
                <i class="ni ni-credit-card text-lg opacity-10" aria-hidden="true"></i>
              </div>
            </div>
            <div class="mt-2">
              <span class="text-sm text-muted">Pendiente: ${{ formatCurrency(metrics.totalEarned - metrics.totalPaid) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Resumen de tareas recientes -->
      <div class="col-lg-12 mb-4">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Resumen de Tareas</h6>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Taller</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Oficio</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="6" class="text-center py-4">
                      <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                      <p class="mt-2 text-sm text-secondary">Cargando datos...</p>
                    </td>
                  </tr>
                  <template v-else>
                    <tr v-for="task in recentTasks" :key="task.id">
                      <td>
                        <h6 class="mb-0 text-sm">#{{ task.production?.id }} - {{ task.production?.name || 'Sin nombre' }}</h6>
                      </td>
                      <td>
                        <h6 class="mb-0 text-sm">{{ task.model?.model?.name || 'N/A' }}</h6>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <h6 class="mb-0 text-sm">{{ task.oficio?.name || 'N/A' }}</h6>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <h6 class="mb-0 text-sm">{{ task.received_quantity || 0 }}</h6>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm" :class="getStatusBadgeClass(task)">
                          {{ getStatusText(task) }}
                        </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <h6 class="mb-0 text-sm">${{ formatCurrency(task.total || 0) }}</h6>
                      </td>
                    </tr>
                    <tr v-if="recentTasks.length === 0">
                      <td colspan="6" class="text-center text-xxs">No hay tareas disponibles</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OperadorDashboard',
  data() {
    return {
      user: {},
      metrics: {
        totalTasks: 0,
        pendingTasks: 0,
        deliveredTasks: 0,
        completedTasks: 0,
        totalEarned: 0,
        totalPaid: 0,
      },
      recentTasks: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters('productionUsers', ['allData']),
  },
  methods: {
    async fetchMetrics() {
      this.loading = true;
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
          return;
        }

        // Obtener todas las tareas sin paginación
        const params = { user_id: user.id, page: 'all' };
        const response = await this.$store.dispatch('productionUsers/getAll', params);
        const tasks = response || [];

        // Calcular métricas
        this.metrics.totalTasks = tasks.length;
        this.metrics.pendingTasks = tasks.filter(t => !t.received_date).length;
        this.metrics.deliveredTasks = tasks.filter(t => t.delivered_date && !t.validated_date).length;
        this.metrics.completedTasks = tasks.filter(t => t.validated_date).length;
        this.metrics.totalEarned = tasks.reduce((sum, t) => sum + (parseFloat(t.total) || 0), 0);
        this.metrics.totalPaid = tasks.reduce((sum, t) => sum + (parseFloat(t.total_paid) || 0), 0);

        // Obtener tareas recientes (últimas 5)
        this.recentTasks = tasks
          .sort((a, b) => new Date(b.assigned_at || b.created_at) - new Date(a.assigned_at || a.created_at))
          .slice(0, 5);
      } catch (error) {
        console.error('Error al cargar métricas:', error);
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(value) {
      return parseFloat(value || 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getStatusText(task) {
      if (task.validated_date) return 'Completada';
      if (task.delivered_date) return 'Entregada';
      if (task.received_date) return 'Recibida';
      return 'Pendiente';
    },
    getStatusBadgeClass(task) {
      if (task.validated_date) return 'bg-gradient-success';
      if (task.delivered_date) return 'bg-gradient-info';
      if (task.received_date) return 'bg-gradient-warning';
      return 'bg-gradient-secondary';
    },
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.user = user;
    }
    this.fetchMetrics();
  },
};
</script>

<style scoped>
.card {
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.icon-shape {
  width: 48px;
  height: 48px;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
